import BaseService from './base.service'
export class StoreInvoiceService extends BaseService {
  /**
   * The constructor for the ArtistService.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/store/invoice', parameters)
  }
  changeStatus(store_invoice_id, status, approval_note) {
    return this.submit('post', `/${this.endpoint}/status`, { store_invoice_id, status, approval_note })
  }
}
